import React from 'react';
import { Instagram, Mail, Phone } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="container-cift py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="md:col-span-1">
            <img
              src="/logo-dark.svg"
              alt="CIFT Studio"
              className="h-20 w-auto mb-4" />

            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.about')}
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-gold font-semibold uppercase tracking-wider text-sm mb-4">
              {t('footer.services')}
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('business')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  {t('nav.business')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('wedding')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  {t('nav.weddings')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('wedding')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  {t('wedding.services.s2.title')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  {t('nav.portfolio')}
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gold font-semibold uppercase tracking-wider text-sm mb-4">
              {t('footer.information')}
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('ablauf')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  {t('nav.process')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  FAQ
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('kontakt')}
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-gold font-semibold uppercase tracking-wider text-sm mb-4">
              {t('nav.contact')}
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:Cift.Studio@gmail.com"
                  className="flex items-center text-gray-400 hover:text-gold transition-colors text-sm">

                  <Mail size={16} className="mr-2" />
                  Cift.Studio@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/cift.wedding"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-400 hover:text-gold transition-colors text-sm">

                  <Instagram size={16} className="mr-2" />
                  @cift.studio
                </a>
              </li>
              <li>
                <a
                  href="https://ciftstudio.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors text-sm">

                  ciftstudio.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex space-x-6">
            <Link
              to="/impressum"
              className="text-gray-500 hover:text-gold transition-colors"
              style={{ fontSize: '13px' }}
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-gray-500 hover:text-gold transition-colors"
              style={{ fontSize: '13px' }}
            >
              {t('footer.legal.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;